class TopProducts {
  constructor() {
    this.grid = document.querySelector("#product-grid");
    if (!this.grid) return;

    const params = new URLSearchParams(location.search);
    const top = params.get("top");

    if (!top) return;

    this.handles = top
      .split(",")
      .map(v => v.trim())
      .filter(Boolean);

    this.renderSkeletons();
    this.load();
  }

  /**
   * skeleton（保持顺序）
   */
  renderSkeletons() {
    this.handles.forEach(handle => {
      const el = document.createElement("div");
      el.className = "f-column top-product is-loading";
      el.dataset.productHandle = handle;

      el.innerHTML = this.getSkeletonHTML();

      this.grid.prepend(el);
    });
  }

  /**
   * ⭐ 关键：先全部 fetch，再按顺序渲染
   */
  async load() {

    // ==========================
    // 1️⃣ 并行请求（但不插入）
    // ==========================
    const results = await Promise.all(
      this.handles.map(handle => this.fetchProduct(handle))
    );

    // ==========================
    // 2️⃣ 按 URL 顺序处理
    // ==========================
    results.forEach((html, index) => {
      const handle = this.handles[index];

      if (!html) return;

      const temp = document.createElement("div");
      temp.innerHTML = html;

      const newNode = temp.querySelector(".top-product");
      if (!newNode) return;

      // ❗ 删除旧位置（防重复）
      this.removeExisting(handle);

      // ❗ 按顺序插入（关键）
      this.grid.prepend(newNode);
    });

    // ==========================
    // 3️⃣ 修正最终 DOM 顺序（强保险）
    // ==========================
    this.reorderDom();
  }

  /**
   * ⭐ 强制按 handles 顺序重新排列 DOM（最终保险）
   */
  reorderDom() {
    const nodes = Array.from(
      this.grid.querySelectorAll(".top-product")
    );

    const map = new Map();

    nodes.forEach(node => {
      const h = node.dataset.productHandle;
      if (h) map.set(h, node);
    });

    // 只处理 top handles
    this.handles.forEach(handle => {
      const node = map.get(handle);
      if (node) {
        this.grid.prepend(node);
      }
    });
  }

  /**
   * 删除旧位置（防重复）
   */
  removeExisting(handle) {
    const nodes = this.grid.querySelectorAll(
      `[data-product-handle="${handle}"]`
    );

    nodes.forEach(n => n.remove());
  }

  /**
   * fetch
   */
  async fetchProduct(handle) {
    try {
      const res = await fetch(`/products/${handle}?view=top-card`);
      if (!res.ok) return null;
      return await res.text();
    } catch (e) {
      console.error("fetch failed:", handle);
      return null;
    }
  }

  /**
   * skeleton
   */
  getSkeletonHTML() {
    return `
      <div class="product-card skeleton">
        <div class="skeleton-img"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line short"></div>
      </div>
    `;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new TopProducts();
});